import { useRef, useState } from "react";
import { useDataContext } from "../../Context/DataContext";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { Link } from "react-router-dom";

export const Project = () => {
    const { project } = useDataContext();

    const [noOfElement, setNoOfElement] = useState(2);
    const totalProjects = project.length;
    // eslint-disable-next-line
    const loadMore = () => {
        setNoOfElement((prev) => Math.min(prev + 2, totalProjects));
    };

    const slice = project.slice(0, noOfElement);

    // --- GSAP Animation Refs ---
    const sectionRef = useRef(null);
    const titleRef = useRef(null);
    const buttonRef = useRef(null)

    useGSAP(() => {
        // --- Animate the "Projects" Title ---
        gsap.from(titleRef.current, {
            y: 50,
            opacity: 0,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top 80%',
                toggleActions: 'play none none reverse',
            }
        });

        // Loop through each project item to apply alternating animations
        gsap.utils.toArray(".project-item").forEach((item, index) => {
            const isOdd = index % 2 !== 0;

            // Animate the project title (e.g., "E-Commerce Store")
            gsap.from(item.querySelector('.project-name'), {
                y: 20,
                opacity: 0,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: item,
                    start: 'top 80%',
                    toggleActions: 'play none none reverse',
                }
            });

            // Animate the image and info block
            gsap.from(item.querySelectorAll('.project-visual, .project-info'), {
                opacity: 0,
                duration: 1.2,
                ease: "power2.out",
                x: isOdd ? 100 : -100, // Alternating slide direction
                stagger: 0.1,
                scrollTrigger: {
                    trigger: item,
                    start: 'top 80%',
                    toggleActions: 'play none none reverse',
                }
            });
        });

        // --- Animate the "More Projects" Button ---
        // This will trigger after all the project items have started animating
        gsap.from(buttonRef.current, {
            y: 30,
            opacity: 0,
            duration: 0.7,
            ease: "power2.out",
            scrollTrigger: {
                trigger: buttonRef.current,
                start: 'top 80%', // Wait until the button is near the bottom of the screen
                toggleActions: 'play none none reverse',
            }
        });

    }, { scope: sectionRef });

    return (
        <>
            <div ref={sectionRef} className='md:px-20 xl:px-32 text-center text-surface lg:text-left'>
                <div className='container mx-auto pt-8 sm:pt-16 px-9'>
                    <p ref={titleRef} className='font-pockota font-bold text-2xl sm:text-3xl md:text-4xl text-y-col'>Projects</p>
                </div>
                {slice.map((project, index) => (
                    <div className='project-item container mx-auto py-10 px-9' key={index}>
                        <div className="flex gap-10 justify-center pb-10">
                            <div className={`lg:w-1/2 hidden lg:block ${project.class_title || null}`}></div>
                            <div className='lg:w-1/2 text-center lg:text-left'>
                                <p className='project-name font-pockota font-bold text-2xl sm:text-3xl md:text-4xl text-b-col'>{project.name}</p>
                            </div>
                        </div>
                        <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-10 dark:text-tx-col">
                            <div className={`project-visual lg:w-1/2 w-full flex justify-center relative overflow-hidden rounded-lg ${project.class || null}`}>
                                <img className='w-full h-full' src={project.img} alt={`Project - ${project.name}`} title={`Project - ${project.name}`} />
                                <a href={project.link} target='_blank' rel="noreferrer" className='flex gap-2 justify-center items-center backdrop-blur-lg bg-[#00000040] text-y-col absolute bottom-0 w-full py-1.5 text-xs md:text-sm xl:text-base'>
                                    Preview
                                    <svg
                                        className='text-b-col'
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                        height="1.1em"
                                        width="1.1em"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M10.604 1h4.146a.25.25 0 01.25.25v4.146a.25.25 0 01-.427.177L13.03 4.03 9.28 7.78a.75.75 0 01-1.06-1.06l3.75-3.75-1.543-1.543A.25.25 0 0110.604 1zM3.75 2A1.75 1.75 0 002 3.75v8.5c0 .966.784 1.75 1.75 1.75h8.5A1.75 1.75 0 0014 12.25v-3.5a.75.75 0 00-1.5 0v3.5a.25.25 0 01-.25.25h-8.5a.25.25 0 01-.25-.25v-8.5a.25.25 0 01.25-.25h3.5a.75.75 0 000-1.5h-3.5z"
                                        />
                                    </svg>
                                </a>
                            </div>
                            <div className='project-info lg:w-1/2 flex flex-col gap-6'>
                                <div className='flex flex-col gap-6'>
                                    <h3 className='text-sm sm:text-base lg:text-lg font-medium'>{project.duration}</h3>
                                    <p className='text-sm sm:text-base lg:text-lg font-light text-justify'>{project.p1}</p>
                                    <p className='text-sm sm:text-base lg:text-lg font-light text-justify'>{project.p2}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                <div className='flex flex-col justify-center'>
                    <Link ref={buttonRef} to='/projects' className='backdrop-blur-lg bg-[#00000040] text-blue-500 border border-y-col rounded-full mt-5 px-4 py-1 w-fit mx-auto'>More Projects</Link>
                    {/* {noOfElement < totalProjects && (
                        <>
                            <button
                                className='backdrop-blur-lg bg-[#00000040] text-blue-500 border border-y-col rounded-full mt-5 px-4 py-1 w-fit mx-auto'
                                onClick={loadMore}
                            >
                                Load More
                            </button>
                        </>
                    )} */}
                </div>
            </div>
        </>
    )
}
